{
  "three-acts": {
    "name": "3막 구조",
    "summary": "설정, 대립, 해결. 대부분의 소설과 영화가 공유하는 구조예요.",
    "bestFor": "모든 장르와 단순하게 유지하고 싶은 초고에 적합해요.",
    "metaTitle": "3막 구조 스토리 템플릿 — Musael",
    "metaDescription": "설정, 대립, 해결로 이어지는 대부분의 소설과 영화의 구조예요. 모든 장르와 단순하게 쓰고 싶은 초고에 활용하세요.",
    "acts": [
      {
        "title": "제I막: 설정",
        "synopsis": "주인공이 누구인지, 무엇을 원하는지, 어떤 사건이 평범한 삶을 끝내는지 보여 줘요.",
        "chapters": [
          {
            "title": "일상 세계",
            "synopsis": "익숙한 곳에 있는 주인공과, 이야기가 시험할 욕망과 결점을 보여 줘요.",
            "scenes": [
              {
                "title": "첫 이미지",
                "synopsis": "아무것도 변하기 전 주인공의 모습을 담아요."
              },
              {
                "title": "이야기의 후크",
                "synopsis": "작지만 이상한 일이 앞으로의 문제를 예고해요."
              }
            ]
          },
          {
            "title": "도화선이 되는 사건",
            "synopsis": "주인공이 무시할 수 없는 사건이에요.",
            "scenes": [
              {
                "title": "촉발 사건",
                "synopsis": "문제가 생기고, 저절로 사라지지 않아요."
              },
              {
                "title": "망설임",
                "synopsis": "주인공이 망설이는 동안 무엇을 잃을 수 있는지 드러나요."
              }
            ]
          },
          {
            "title": "문턱 넘기",
            "synopsis": "주인공이 결심해요. 쉽게 돌아갈 길은 없어요.",
            "scenes": [
              {
                "title": "결정",
                "synopsis": "주인공이 행동하기로 하고 익숙한 것을 뒤로해요."
              }
            ]
          }
        ]
      },
      {
        "title": "제II막: 대립",
        "synopsis": "주인공이 시도하고 실패하며 배우는 동안, 걸린 것이 점점 커져요.",
        "chapters": [
          {
            "title": "커지는 위험과 대가",
            "synopsis": "새로운 규칙, 동료와 적이 등장해요. 첫 승리에도 대가가 있어요.",
            "scenes": [
              {
                "title": "첫 시험",
                "synopsis": "주인공이 새로운 세계를 만나고 일부를 잘못 이해해요."
              },
              {
                "title": "동료와 적",
                "synopsis": "누가 돕고 누가 방해하는지, 그 이유를 보여 줘요."
              }
            ]
          },
          {
            "title": "이야기의 중간점",
            "synopsis": "이야기가 무엇에 관한 것인지 바꾸는 반전이에요.",
            "scenes": [
              {
                "title": "중간점",
                "synopsis": "거짓 승리나 거짓 패배를 겪고, 주인공은 반응만 하던 태도에서 주도하는 태도로 바뀌어요."
              }
            ]
          },
          {
            "title": "모든 것이 무너지다",
            "synopsis": "적이 조여 오고, 주인공은 자신의 결점 때문에 큰 대가를 치러요.",
            "scenes": [
              {
                "title": "조여 오는 압박",
                "synopsis": "모든 계획이 저항에 부딪히고 관계에 금이 가요."
              },
              {
                "title": "모든 것을 잃다",
                "synopsis": "가장 낮은 순간이에요. 목표는 영영 닿을 수 없을 것 같아요."
              }
            ]
          }
        ]
      },
      {
        "title": "제III막: 해결",
        "synopsis": "주인공이 변하고 마지막 시험에 맞서며 새로운 일상이 시작돼요.",
        "chapters": [
          {
            "title": "이야기의 절정",
            "synopsis": "제II막에서 배운 교훈으로 이겨 내는 마지막 대결이에요.",
            "scenes": [
              {
                "title": "마지막 계획",
                "synopsis": "주인공이 배운 것을 모아 마지막으로 시도해요."
              },
              {
                "title": "절정",
                "synopsis": "승패를 결정짓는 대결이에요."
              }
            ]
          },
          {
            "title": "새로운 일상",
            "synopsis": "주인공과 세상에 무엇이 달라졌는지 보여 줘요.",
            "scenes": [
              {
                "title": "마무리 이미지",
                "synopsis": "첫 이미지를 비추며 주인공이 얼마나 멀리 왔는지 보여 줘요."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "영웅의 여정",
    "summary": "모험의 부름부터 귀향까지 열두 단계를 출발, 입문, 귀환으로 묶은 구조예요.",
    "bestFor": "판타지, 모험, 탐색 여정에 적합해요.",
    "metaTitle": "영웅의 여정 스토리 템플릿 — Musael",
    "metaDescription": "모험의 부름부터 귀향까지 열두 단계를 출발, 입문, 귀환으로 나눠요. 판타지, 모험, 탐색 여정에 활용하세요.",
    "acts": [
      {
        "title": "출발",
        "synopsis": "주인공이 익숙한 세계를 떠나요.",
        "chapters": [
          {
            "title": "일상 세계",
            "synopsis": "모험 전 주인공의 집, 습관, 그리고 부족한 것을 보여 줘요.",
            "scenes": [
              {
                "title": "일상 세계",
                "synopsis": "모험 전 주인공의 집, 습관, 그리고 부족한 것을 보여 줘요."
              }
            ]
          },
          {
            "title": "모험의 부름",
            "synopsis": "도전이나 메시지가 일상 세계를 흔들어요.",
            "scenes": [
              {
                "title": "모험의 부름",
                "synopsis": "도전이나 메시지가 일상 세계를 흔들어요."
              }
            ]
          },
          {
            "title": "부름의 거부",
            "synopsis": "두려움이나 의무가 주인공을 붙잡아요.",
            "scenes": [
              {
                "title": "부름의 거부",
                "synopsis": "두려움이나 의무가 주인공을 붙잡아요."
              }
            ]
          },
          {
            "title": "조력자와의 만남",
            "synopsis": "누군가 조언, 훈련, 또는 선물을 건네요.",
            "scenes": [
              {
                "title": "조력자와의 만남",
                "synopsis": "누군가 조언, 훈련, 또는 선물을 건네요."
              }
            ]
          },
          {
            "title": "첫 문턱 넘기",
            "synopsis": "주인공이 특별한 세계로 들어가요.",
            "scenes": [
              {
                "title": "첫 문턱 넘기",
                "synopsis": "주인공이 특별한 세계로 들어가요."
              }
            ]
          }
        ]
      },
      {
        "title": "입문",
        "synopsis": "특별한 세계에서의 시험과 가장 큰 시련이 기다려요.",
        "chapters": [
          {
            "title": "시험, 동료와 적",
            "synopsis": "주인공이 새로운 세계의 규칙을 배워요.",
            "scenes": [
              {
                "title": "시험, 동료와 적",
                "synopsis": "주인공이 새로운 세계의 규칙을 배워요."
              }
            ]
          },
          {
            "title": "가장 깊은 동굴로의 접근",
            "synopsis": "핵심적인 위험에 대비해요.",
            "scenes": [
              {
                "title": "가장 깊은 동굴로의 접근",
                "synopsis": "핵심적인 위험에 대비해요."
              }
            ]
          },
          {
            "title": "결정적인 시련",
            "synopsis": "생사가 걸린 위기 속에서 주인공 안의 무언가가 죽어요.",
            "scenes": [
              {
                "title": "결정적인 시련",
                "synopsis": "생사가 걸린 위기 속에서 주인공 안의 무언가가 죽어요."
              }
            ]
          },
          {
            "title": "보상",
            "synopsis": "주인공이 보물, 지식, 또는 화해를 얻어요.",
            "scenes": [
              {
                "title": "보상",
                "synopsis": "주인공이 보물, 지식, 또는 화해를 얻어요."
              }
            ]
          }
        ]
      },
      {
        "title": "귀환",
        "synopsis": "집으로 가는 길, 마지막 시험, 주인공이 가져오는 것을 다뤄요.",
        "chapters": [
          {
            "title": "돌아오는 길",
            "synopsis": "주인공이 집으로 향해요. 쫓기는 경우도 많아요.",
            "scenes": [
              {
                "title": "돌아오는 길",
                "synopsis": "주인공이 집으로 향해요. 쫓기는 경우도 많아요."
              }
            ]
          },
          {
            "title": "부활",
            "synopsis": "배운 모든 것을 활용하는 마지막 시험이에요.",
            "scenes": [
              {
                "title": "부활",
                "synopsis": "배운 모든 것을 활용하는 마지막 시험이에요."
              }
            ]
          },
          {
            "title": "영약을 가지고 귀환",
            "synopsis": "주인공이 변한 모습으로, 나눌 것을 가지고 집에 돌아와요.",
            "scenes": [
              {
                "title": "영약을 가지고 귀환",
                "synopsis": "주인공이 변한 모습으로, 나눌 것을 가지고 집에 돌아와요."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "15개 비트 개요",
    "summary": "시나리오 작가가 쓰는 비트 시트예요. 세 막에 열다섯 전환점을 배치해요.",
    "bestFor": "전환점이 뚜렷하고 짜임새 있는 상업적 플롯에 적합해요.",
    "metaTitle": "15개 비트 스토리 템플릿 — Musael",
    "metaDescription": "시나리오 작가의 비트 시트로 세 막에 열다섯 전환점을 배치해요. 전환점이 뚜렷하고 짜임새 있는 상업적 플롯에 적합해요.",
    "acts": [
      {
        "title": "제I막",
        "synopsis": "이전의 세계와 그곳을 떠나는 선택을 보여 줘요.",
        "chapters": [
          {
            "title": "첫 이미지",
            "synopsis": "이야기 시작 전의 주인공과 세상을 보여 줘요.",
            "scenes": [
              {
                "title": "첫 이미지",
                "synopsis": "이야기 시작 전의 주인공과 세상을 보여 줘요."
              }
            ]
          },
          {
            "title": "주제 제시",
            "synopsis": "누군가 이야기의 진짜 주제를 말하지만 주인공은 아직 알아차리지 못해요.",
            "scenes": [
              {
                "title": "주제 제시",
                "synopsis": "누군가 이야기의 진짜 주제를 말하지만 주인공은 아직 알아차리지 못해요."
              }
            ]
          },
          {
            "title": "설정",
            "synopsis": "주인공의 삶, 주변 사람들, 고쳐야 할 것을 보여 줘요.",
            "scenes": [
              {
                "title": "설정",
                "synopsis": "주인공의 삶, 주변 사람들, 고쳐야 할 것을 보여 줘요."
              }
            ]
          },
          {
            "title": "촉매",
            "synopsis": "이야기를 움직이기 시작하는 사건이에요.",
            "scenes": [
              {
                "title": "촉매",
                "synopsis": "이야기를 움직이기 시작하는 사건이에요."
              }
            ]
          },
          {
            "title": "망설임",
            "synopsis": "주인공이 무엇을 해야 할지 망설여요.",
            "scenes": [
              {
                "title": "망설임",
                "synopsis": "주인공이 무엇을 해야 할지 망설여요."
              }
            ]
          },
          {
            "title": "2막 진입",
            "synopsis": "주인공이 새로운 길을 선택해요.",
            "scenes": [
              {
                "title": "2막 진입",
                "synopsis": "주인공이 새로운 길을 선택해요."
              }
            ]
          }
        ]
      },
      {
        "title": "제II막",
        "synopsis": "기본 설정이 약속한 재미를 보여 준 뒤 추락해요.",
        "chapters": [
          {
            "title": "보조 이야기",
            "synopsis": "주제를 담는 부차적인 이야기예요. 관계를 다루는 경우가 많아요.",
            "scenes": [
              {
                "title": "보조 이야기",
                "synopsis": "주제를 담는 부차적인 이야기예요. 관계를 다루는 경우가 많아요."
              }
            ]
          },
          {
            "title": "재미와 놀이",
            "synopsis": "기본 설정의 약속을 실현해요. 독자가 기대하고 찾아온 내용이에요.",
            "scenes": [
              {
                "title": "재미와 놀이",
                "synopsis": "기본 설정의 약속을 실현해요. 독자가 기대하고 찾아온 내용이에요."
              }
            ]
          },
          {
            "title": "중간점",
            "synopsis": "거짓 승리나 패배로 걸린 것이 더 커져요.",
            "scenes": [
              {
                "title": "중간점",
                "synopsis": "거짓 승리나 패배로 걸린 것이 더 커져요."
              }
            ]
          },
          {
            "title": "적들이 다가오다",
            "synopsis": "안에서는 의심이, 밖에서는 압박이 커져요.",
            "scenes": [
              {
                "title": "적들이 다가오다",
                "synopsis": "안에서는 의심이, 밖에서는 압박이 커져요."
              }
            ]
          },
          {
            "title": "모든 것을 잃다",
            "synopsis": "중간점과 반대되는, 가장 낮은 순간이에요.",
            "scenes": [
              {
                "title": "모든 것을 잃다",
                "synopsis": "중간점과 반대되는, 가장 낮은 순간이에요."
              }
            ]
          },
          {
            "title": "영혼의 어두운 밤",
            "synopsis": "주인공이 잃은 것을 슬퍼하고 교훈을 찾아요.",
            "scenes": [
              {
                "title": "영혼의 어두운 밤",
                "synopsis": "주인공이 잃은 것을 슬퍼하고 교훈을 찾아요."
              }
            ]
          }
        ]
      },
      {
        "title": "제III막",
        "synopsis": "배운 교훈을 실천해요.",
        "chapters": [
          {
            "title": "3막 진입",
            "synopsis": "보조 이야기에서 나온 새로운 생각이 길을 열어요.",
            "scenes": [
              {
                "title": "3막 진입",
                "synopsis": "보조 이야기에서 나온 새로운 생각이 길을 열어요."
              }
            ]
          },
          {
            "title": "피날레",
            "synopsis": "주인공이 망가진 것을 바로잡고 영구적으로 달라져요.",
            "scenes": [
              {
                "title": "피날레",
                "synopsis": "주인공이 망가진 것을 바로잡고 영구적으로 달라져요."
              }
            ]
          },
          {
            "title": "마지막 이미지",
            "synopsis": "첫 이미지를 비추는, 이야기 이후의 세상을 보여 줘요.",
            "scenes": [
              {
                "title": "마지막 이미지",
                "synopsis": "첫 이미지를 비추는, 이야기 이후의 세상을 보여 줘요."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "7단계 구조",
    "summary": "결말에서 거꾸로 계획해요. 후크, 전환, 압박, 중간점, 해결을 배치해요.",
    "bestFor": "결말을 먼저 아는 작가에게 적합해요.",
    "metaTitle": "7단계 스토리 템플릿 — Musael",
    "metaDescription": "결말에서 거꾸로 후크, 전환, 압박, 중간점, 해결을 계획해요. 결말을 먼저 아는 작가에게 적합해요.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "후크",
            "synopsis": "해결 때의 상태와 반대되는 출발 상태예요.",
            "scenes": [
              {
                "title": "후크",
                "synopsis": "해결 때의 상태와 반대되는 출발 상태예요."
              }
            ]
          },
          {
            "title": "플롯 전환 1",
            "synopsis": "갈등이 시작되고 주인공은 행동하도록 떠밀려요.",
            "scenes": [
              {
                "title": "플롯 전환 1",
                "synopsis": "갈등이 시작되고 주인공은 행동하도록 떠밀려요."
              }
            ]
          },
          {
            "title": "압박 1",
            "synopsis": "적대자가 압박을 가하고 주인공은 행동해야 해요.",
            "scenes": [
              {
                "title": "압박 1",
                "synopsis": "적대자가 압박을 가하고 주인공은 행동해야 해요."
              }
            ]
          },
          {
            "title": "중간점",
            "synopsis": "주인공이 반응하는 데서 스스로 행동하는 쪽으로 바뀌어요.",
            "scenes": [
              {
                "title": "중간점",
                "synopsis": "주인공이 반응하는 데서 스스로 행동하는 쪽으로 바뀌어요."
              }
            ]
          },
          {
            "title": "압박 2",
            "synopsis": "일이 크게 어긋나고 계획이 실패해요.",
            "scenes": [
              {
                "title": "압박 2",
                "synopsis": "일이 크게 어긋나고 계획이 실패해요."
              }
            ]
          },
          {
            "title": "플롯 전환 2",
            "synopsis": "주인공이 승리에 필요한 마지막 조각을 얻어요.",
            "scenes": [
              {
                "title": "플롯 전환 2",
                "synopsis": "주인공이 승리에 필요한 마지막 조각을 얻어요."
              }
            ]
          },
          {
            "title": "해결",
            "synopsis": "출발의 후크에 답하는 결말의 상태예요.",
            "scenes": [
              {
                "title": "해결",
                "synopsis": "출발의 후크에 답하는 결말의 상태예요."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "기승전결",
    "summary": "갈등 대신 전환을 중심으로 구성한 네 흐름이에요.",
    "bestFor": "문학 소설, 단편, 인물 중심의 잔잔한 이야기에 적합해요.",
    "metaTitle": "기승전결 스토리 템플릿 — Musael",
    "metaDescription": "갈등 대신 전환을 중심으로 구성한 네 흐름이에요. 문학 소설, 단편, 인물 중심의 잔잔한 이야기에 활용하세요.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "기: 도입",
            "synopsis": "인물과 그들의 세계를 차분히 보여 줘요.",
            "scenes": [
              {
                "title": "도입",
                "synopsis": "누가, 어디에 있고, 일상이 어떤 모습인지 보여 줘요."
              }
            ]
          },
          {
            "title": "승: 전개",
            "synopsis": "상황이 깊어지지만 아직 전환은 없어요.",
            "scenes": [
              {
                "title": "전개",
                "synopsis": "인물을 더 잘 알게 되고 작은 변화들이 생겨요."
              }
            ]
          },
          {
            "title": "전: 전환",
            "synopsis": "예상치 못한 요소가 모든 것을 바라보는 방식을 바꿔요.",
            "scenes": [
              {
                "title": "전환",
                "synopsis": "겉보기엔 관련 없어 보이는 새로운 무언가가 나타나요."
              }
            ]
          },
          {
            "title": "결: 통합",
            "synopsis": "각 부분이 모여 새로운 이해를 이루어요.",
            "scenes": [
              {
                "title": "통합",
                "synopsis": "전환과 이야기가 만나며 의미가 달라져요."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "미스터리",
    "summary": "범죄, 단서와 거짓 단서를 따라가는 수사, 독자에게 공정한 진상 공개로 이어져요.",
    "bestFor": "범죄 소설, 탐정 소설, 코지 미스터리에 적합해요.",
    "metaTitle": "미스터리 스토리 템플릿 — Musael",
    "metaDescription": "범죄, 단서와 거짓 단서를 따라가는 수사, 공정한 진상 공개를 구성해요. 범죄 소설, 탐정 소설, 코지 미스터리에 적합해요.",
    "acts": [
      {
        "title": "범죄",
        "synopsis": "뭔가 잘못됐고 누군가는 이유를 밝혀야 해요.",
        "chapters": [
          {
            "title": "발견",
            "synopsis": "범죄나 실종이 드러나요.",
            "scenes": [
              {
                "title": "시신",
                "synopsis": "범죄가 발견되고 첫인상과 첫 질문이 생겨요."
              },
              {
                "title": "탐정",
                "synopsis": "누가 수사하며, 그 사람에게 왜 중요한지 보여 줘요."
              }
            ]
          }
        ]
      },
      {
        "title": "수사",
        "synopsis": "단서, 용의자, 거짓 단서를 따라가요.",
        "chapters": [
          {
            "title": "용의자",
            "synopsis": "동기와 알리바이가 있는 모든 사람을 살펴봐요.",
            "scenes": [
              {
                "title": "면담",
                "synopsis": "각 용의자에게 거짓말할 이유가 생겨요."
              },
              {
                "title": "첫 단서",
                "synopsis": "나중에 중요해질 사실이에요. 독자에게 공정하게 제시하세요."
              }
            ]
          },
          {
            "title": "거짓 단서",
            "synopsis": "수사가 잘못된 방향으로 흘러가요.",
            "scenes": [
              {
                "title": "오도하는 단서",
                "synopsis": "증거가 엉뚱한 사람을 가리켜요."
              },
              {
                "title": "사태의 확대",
                "synopsis": "두 번째 범죄나 위협으로 걸린 것이 커져요."
              }
            ]
          },
          {
            "title": "숨겨진 진실",
            "synopsis": "탐정이 처음부터 그 자리에 있던 것을 알아봐요.",
            "scenes": [
              {
                "title": "빠진 조각",
                "synopsis": "작은 세부 사항이 앞선 단서들을 맞춰 줘요."
              }
            ]
          }
        ]
      },
      {
        "title": "진상 공개",
        "synopsis": "해결과 그 대가를 보여 줘요.",
        "chapters": [
          {
            "title": "해답",
            "synopsis": "모든 단서가 설명돼요.",
            "scenes": [
              {
                "title": "진상 공개",
                "synopsis": "범인이 밝혀지고 추론 과정이 제시돼요."
              },
              {
                "title": "사건 이후",
                "synopsis": "정의, 또는 정의의 부재와 탐정에게 남는 것을 보여 줘요."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "로맨스",
    "summary": "두 사람, 그들을 갈라놓는 것, 서로를 선택하기 위해 필요한 것을 다뤄요.",
    "bestFor": "어떤 배경의 로맨스와 사랑 이야기에도 적합해요.",
    "metaTitle": "로맨스 스토리 템플릿 — Musael",
    "metaDescription": "두 사람, 그들을 갈라놓는 것, 서로를 선택하기 위해 필요한 것을 구성해요. 어떤 배경의 로맨스와 사랑 이야기에도 적합해요.",
    "acts": [
      {
        "title": "사랑에 빠지기",
        "synopsis": "두 사람이 만나고 저항하다가 사랑에 빠지기 시작해요.",
        "chapters": [
          {
            "title": "만남",
            "synopsis": "설렘과 장애물이 함께하는 첫 만남이에요.",
            "scenes": [
              {
                "title": "첫 대면",
                "synopsis": "두 주인공이 만나요. 상대의 무언가가 마음속 깊이 파고들어요."
              },
              {
                "title": "저항",
                "synopsis": "이 관계가 잘될 수 없는 이유예요. 목표, 상처, 또는 상황이 가로막아요."
              }
            ]
          },
          {
            "title": "가까워지기",
            "synopsis": "함께할 수밖에 없게 된 두 사람은 서로의 진짜 모습을 봐요.",
            "scenes": [
              {
                "title": "우연히 함께",
                "synopsis": "어떤 상황이 두 사람을 가까이 머물게 해요."
              },
              {
                "title": "첫 진실한 순간",
                "synopsis": "상대가 진짜 누구인지 잠깐 엿봐요."
              }
            ]
          }
        ]
      },
      {
        "title": "의심하기",
        "synopsis": "마음을 정한 뒤, 그 결심을 깨뜨리는 두려움이 찾아와요.",
        "chapters": [
          {
            "title": "이야기의 중간점",
            "synopsis": "두 사람은 자신의 감정을 받아들여요.",
            "scenes": [
              {
                "title": "마음 정하기",
                "synopsis": "입맞춤, 고백, 또는 약속이에요."
              }
            ]
          },
          {
            "title": "균열",
            "synopsis": "오래된 상처나 외부 장애물이 일단은 이겨요.",
            "scenes": [
              {
                "title": "의심",
                "synopsis": "오래된 두려움이 돌아와요."
              },
              {
                "title": "이별",
                "synopsis": "각자 자신이 옳다고 믿으며 헤어져요."
              }
            ]
          }
        ]
      },
      {
        "title": "선택하기",
        "synopsis": "성장, 큰 결단의 표현, 함께할 미래를 보여 줘요.",
        "chapters": [
          {
            "title": "함께",
            "synopsis": "각자가 상대에게 어울릴 만큼 변해요.",
            "scenes": [
              {
                "title": "큰 결단의 표현",
                "synopsis": "한 사람이 자신의 변화를 보여 주려고 모든 것을 걸어요."
              },
              {
                "title": "오래오래 행복하게",
                "synopsis": "또는 지금은 행복하게. 두 사람이 선택한 미래예요."
              }
            ]
          }
        ]
      }
    ]
  }
}
